import React, { useEffect } from 'react';
import { View } from 'react-native';
import { Slot, usePathname, useNavigation } from 'expo-router';
import SideMenu from '@/shared/components/navigation/SideMenu';
import styled from '@emotion/native';
import useIsDesktop from '@/shared/hooks/useIsDesktop';

import DesktopHeader from '@/shared/components/navigation/DesktopHeader';
import MobileHeader from '@/shared/components/navigation/MobileHeader';
import { white, sand } from '@/shared/styles/colors';
import { IsDesktopProps } from '@/shared/styles/types';
import useStore from '@/stores/useStore';
import MobileMenu from '@/shared/components/navigation/MobileMenu';
import { useUserEvents } from '@/shared/hooks/useUserEvents';
import { ROUTES } from '@/shared/constants/routes';
import { useSaveUserTimeZone } from '@/shared/hooks/useSaveUserTimeZone';

export default function WebLayout() {
  const navigation = useNavigation();
  const isMobileMenuVisible = useStore((state) => state.isMobileMenuVisible);
  const closeMobileMenu = useStore((state) => state.closeMobileMenu);
  const isDesktop = useIsDesktop();
  const pathname = usePathname();

  useUserEvents();
  useSaveUserTimeZone();

  const isVideoSession = pathname === ROUTES.VIDEO_SESSION.path;

  useEffect(() => {
    const unsubscribe = navigation.addListener('state', () => {
      closeMobileMenu();
    });

    return unsubscribe;
  }, [navigation]);

  if (isVideoSession) {
    return (
      <Container>
        <ContentArea isDesktop={isDesktop}>
          <Slot />
        </ContentArea>
      </Container>
    );
  }

  return (
    <Container>
      {isDesktop && <SideMenu />}
      <ContentArea isDesktop={isDesktop}>
        {isDesktop ? <DesktopHeader /> : <MobileHeader />}
        <View style={{ flex: 1 }}>
          <Slot />
          <MobileMenu visible={isMobileMenuVisible} />
        </View>
      </ContentArea>
    </Container>
  );
}

const Container = styled.View({
  flexDirection: 'row',
  height: '100%',
});

const ContentArea = styled.View<IsDesktopProps>(({ isDesktop }) => ({
  flex: 1,
  flexDirection: 'column',
  backgroundColor: isDesktop ? white : sand,
}));
